import { useAppDispatch } from 'app/store/configureStore';
import { useCallback } from 'react';
import { fetchInvitesEffect } from 'app/store/Notifications/effects';
import { Link } from 'types/api.types';

export const useFetchMoreInvites = () => {
  const dispatch = useAppDispatch();
  const fetchMoreInvites = useCallback(
    (Link: Link) => {
      dispatch(fetchInvitesEffect({ next: Link }));
    },
    [dispatch]
  );
  return { fetchMoreInvites };
};
